/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ConfirmEmailReplacementRequestOmitted,
  ConfirmSubscriptionPaymentRequestOmitted,
  GetMembershipAffiliationsResponseDto,
  GetSubscriptionFlowStateResponse,
  MembershipAffiliationPriceDto,
  PatchTransactionInfoRequestOmitted,
  RemoteSsoStartRequest,
  SendSubscriptionTransactionInfoRequestOmitted,
  SendSubscriptionTransactionInfoResponse,
  StartEmailReplacementRequestOmitted,
  StartSubscriptionFlowRequest,
  StartSubscriptionFlowResponse,
} from '../models/index';
import {
    ConfirmEmailReplacementRequestOmittedFromJSON,
    ConfirmEmailReplacementRequestOmittedToJSON,
    ConfirmSubscriptionPaymentRequestOmittedFromJSON,
    ConfirmSubscriptionPaymentRequestOmittedToJSON,
    GetMembershipAffiliationsResponseDtoFromJSON,
    GetMembershipAffiliationsResponseDtoToJSON,
    GetSubscriptionFlowStateResponseFromJSON,
    GetSubscriptionFlowStateResponseToJSON,
    MembershipAffiliationPriceDtoFromJSON,
    MembershipAffiliationPriceDtoToJSON,
    PatchTransactionInfoRequestOmittedFromJSON,
    PatchTransactionInfoRequestOmittedToJSON,
    RemoteSsoStartRequestFromJSON,
    RemoteSsoStartRequestToJSON,
    SendSubscriptionTransactionInfoRequestOmittedFromJSON,
    SendSubscriptionTransactionInfoRequestOmittedToJSON,
    SendSubscriptionTransactionInfoResponseFromJSON,
    SendSubscriptionTransactionInfoResponseToJSON,
    StartEmailReplacementRequestOmittedFromJSON,
    StartEmailReplacementRequestOmittedToJSON,
    StartSubscriptionFlowRequestFromJSON,
    StartSubscriptionFlowRequestToJSON,
    StartSubscriptionFlowResponseFromJSON,
    StartSubscriptionFlowResponseToJSON,
} from '../models/index';

export interface SubscriptionFlowControllerBeginSubscriptionSetupRequest {
    id: string;
    sendSubscriptionTransactionInfoRequestOmitted: SendSubscriptionTransactionInfoRequestOmitted;
}

export interface SubscriptionFlowControllerConfirmEmailReplacementRequest {
    id: string;
    confirmEmailReplacementRequestOmitted: ConfirmEmailReplacementRequestOmitted;
}

export interface SubscriptionFlowControllerConfirmSubscriptionRequest {
    id: string;
    confirmSubscriptionPaymentRequestOmitted: ConfirmSubscriptionPaymentRequestOmitted;
}

export interface SubscriptionFlowControllerGetMembershipAffiliationPriceRequest {
    planId: string;
}

export interface SubscriptionFlowControllerGetSubscriptionFlowStateRequest {
    id: string;
    token?: string;
}

export interface SubscriptionFlowControllerPatchSubscriptionUserRequest {
    id: string;
    patchTransactionInfoRequestOmitted: PatchTransactionInfoRequestOmitted;
}

export interface SubscriptionFlowControllerRemoteSsoStartRequest {
    remoteSsoStartRequest: RemoteSsoStartRequest;
}

export interface SubscriptionFlowControllerStartEmailSubscriptionFlowRequest {
    planId: string;
    startSubscriptionFlowRequest: StartSubscriptionFlowRequest;
}

export interface SubscriptionFlowControllerStartReplaceEmailRequest {
    id: string;
    startEmailReplacementRequestOmitted: StartEmailReplacementRequestOmitted;
}

export interface SubscriptionFlowControllerStartSubscriptionChallengeFlowRequest {
    planId: string;
    requestBody?: { [key: string]: string; };
}

export interface SubscriptionFlowControllerStartSubscriptionTestFlowRequest {
    email: string;
}

export interface SubscriptionFlowSSOControllerBeginRequest {
    plan: string;
    provider?: string;
}

/**
 * SubscriptionFlowApi - interface
 * 
 * @export
 * @interface SubscriptionFlowApiInterface
 */
export interface SubscriptionFlowApiInterface {
    /**
     * Send required transaction info. This action will unlock payment setup.
     * @summary 
     * @param {string} id 
     * @param {SendSubscriptionTransactionInfoRequestOmitted} sendSubscriptionTransactionInfoRequestOmitted 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionFlowApiInterface
     */
    subscriptionFlowControllerBeginSubscriptionSetupRaw(requestParameters: SubscriptionFlowControllerBeginSubscriptionSetupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SendSubscriptionTransactionInfoResponse>>;

    /**
     * Send required transaction info. This action will unlock payment setup.
     * 
     */
    subscriptionFlowControllerBeginSubscriptionSetup(requestParameters: SubscriptionFlowControllerBeginSubscriptionSetupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SendSubscriptionTransactionInfoResponse>;

    /**
     * Confirm the email replacement.
     * @summary 
     * @param {string} id 
     * @param {ConfirmEmailReplacementRequestOmitted} confirmEmailReplacementRequestOmitted 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionFlowApiInterface
     */
    subscriptionFlowControllerConfirmEmailReplacementRaw(requestParameters: SubscriptionFlowControllerConfirmEmailReplacementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Confirm the email replacement.
     * 
     */
    subscriptionFlowControllerConfirmEmailReplacement(requestParameters: SubscriptionFlowControllerConfirmEmailReplacementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Confirm subscription
     * @summary 
     * @param {string} id 
     * @param {ConfirmSubscriptionPaymentRequestOmitted} confirmSubscriptionPaymentRequestOmitted 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionFlowApiInterface
     */
    subscriptionFlowControllerConfirmSubscriptionRaw(requestParameters: SubscriptionFlowControllerConfirmSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Confirm subscription
     * 
     */
    subscriptionFlowControllerConfirmSubscription(requestParameters: SubscriptionFlowControllerConfirmSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get the public price for a membership affiliation plan
     * @param {string} planId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionFlowApiInterface
     */
    subscriptionFlowControllerGetMembershipAffiliationPriceRaw(requestParameters: SubscriptionFlowControllerGetMembershipAffiliationPriceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MembershipAffiliationPriceDto>>;

    /**
     * Get the public price for a membership affiliation plan
     */
    subscriptionFlowControllerGetMembershipAffiliationPrice(requestParameters: SubscriptionFlowControllerGetMembershipAffiliationPriceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MembershipAffiliationPriceDto>;

    /**
     * 
     * @summary Get all enabled membership affiliations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionFlowApiInterface
     */
    subscriptionFlowControllerGetMembershipAffiliationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMembershipAffiliationsResponseDto>>;

    /**
     * Get all enabled membership affiliations
     */
    subscriptionFlowControllerGetMembershipAffiliations(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMembershipAffiliationsResponseDto>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionFlowApiInterface
     */
    subscriptionFlowControllerGetStrategiesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    subscriptionFlowControllerGetStrategies(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Get subscription flow state. Can be used to confirm email. Returns data required to take next step in flow.
     * @summary 
     * @param {string} id 
     * @param {string} [token] Optional email confirmation token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionFlowApiInterface
     */
    subscriptionFlowControllerGetSubscriptionFlowStateRaw(requestParameters: SubscriptionFlowControllerGetSubscriptionFlowStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSubscriptionFlowStateResponse>>;

    /**
     * Get subscription flow state. Can be used to confirm email. Returns data required to take next step in flow.
     * 
     */
    subscriptionFlowControllerGetSubscriptionFlowState(requestParameters: SubscriptionFlowControllerGetSubscriptionFlowStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSubscriptionFlowStateResponse>;

    /**
     * Update user info for subscription
     * @summary 
     * @param {string} id 
     * @param {PatchTransactionInfoRequestOmitted} patchTransactionInfoRequestOmitted 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionFlowApiInterface
     */
    subscriptionFlowControllerPatchSubscriptionUserRaw(requestParameters: SubscriptionFlowControllerPatchSubscriptionUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Update user info for subscription
     * 
     */
    subscriptionFlowControllerPatchSubscriptionUser(requestParameters: SubscriptionFlowControllerPatchSubscriptionUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {RemoteSsoStartRequest} remoteSsoStartRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionFlowApiInterface
     */
    subscriptionFlowControllerRemoteSsoStartRaw(requestParameters: SubscriptionFlowControllerRemoteSsoStartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    subscriptionFlowControllerRemoteSsoStart(requestParameters: SubscriptionFlowControllerRemoteSsoStartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Start a new subscription flow using email + confirmation link, or continue an existing one.
     * @summary 
     * @param {string} planId 
     * @param {StartSubscriptionFlowRequest} startSubscriptionFlowRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionFlowApiInterface
     */
    subscriptionFlowControllerStartEmailSubscriptionFlowRaw(requestParameters: SubscriptionFlowControllerStartEmailSubscriptionFlowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StartSubscriptionFlowResponse>>;

    /**
     * Start a new subscription flow using email + confirmation link, or continue an existing one.
     * 
     */
    subscriptionFlowControllerStartEmailSubscriptionFlow(requestParameters: SubscriptionFlowControllerStartEmailSubscriptionFlowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StartSubscriptionFlowResponse>;

    /**
     * Start the process to replace the subscription email.
     * @summary 
     * @param {string} id 
     * @param {StartEmailReplacementRequestOmitted} startEmailReplacementRequestOmitted 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionFlowApiInterface
     */
    subscriptionFlowControllerStartReplaceEmailRaw(requestParameters: SubscriptionFlowControllerStartReplaceEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Start the process to replace the subscription email.
     * 
     */
    subscriptionFlowControllerStartReplaceEmail(requestParameters: SubscriptionFlowControllerStartReplaceEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Start a new subscription flow or continue an existing one.
     * @summary 
     * @param {string} planId 
     * @param {{ [key: string]: string; }} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionFlowApiInterface
     */
    subscriptionFlowControllerStartSubscriptionChallengeFlowRaw(requestParameters: SubscriptionFlowControllerStartSubscriptionChallengeFlowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StartSubscriptionFlowResponse>>;

    /**
     * Start a new subscription flow or continue an existing one.
     * 
     */
    subscriptionFlowControllerStartSubscriptionChallengeFlow(requestParameters: SubscriptionFlowControllerStartSubscriptionChallengeFlowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StartSubscriptionFlowResponse>;

    /**
     * Start a new subscription flow or continue an existing one.
     * @summary 
     * @param {string} email Email to start subscription flow.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionFlowApiInterface
     */
    subscriptionFlowControllerStartSubscriptionTestFlowRaw(requestParameters: SubscriptionFlowControllerStartSubscriptionTestFlowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StartSubscriptionFlowResponse>>;

    /**
     * Start a new subscription flow or continue an existing one.
     * 
     */
    subscriptionFlowControllerStartSubscriptionTestFlow(requestParameters: SubscriptionFlowControllerStartSubscriptionTestFlowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StartSubscriptionFlowResponse>;

    /**
     * 
     * @param {string} plan 
     * @param {string} [provider] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionFlowApiInterface
     */
    subscriptionFlowSSOControllerBeginRaw(requestParameters: SubscriptionFlowSSOControllerBeginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    subscriptionFlowSSOControllerBegin(requestParameters: SubscriptionFlowSSOControllerBeginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionFlowApiInterface
     */
    subscriptionFlowSSOControllerCallbackGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    subscriptionFlowSSOControllerCallbackGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionFlowApiInterface
     */
    subscriptionFlowSSOControllerCallbackPostRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    subscriptionFlowSSOControllerCallbackPost(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class SubscriptionFlowApi extends runtime.BaseAPI implements SubscriptionFlowApiInterface {

    /**
     * Send required transaction info. This action will unlock payment setup.
     * 
     */
    async subscriptionFlowControllerBeginSubscriptionSetupRaw(requestParameters: SubscriptionFlowControllerBeginSubscriptionSetupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SendSubscriptionTransactionInfoResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling subscriptionFlowControllerBeginSubscriptionSetup().'
            );
        }

        if (requestParameters['sendSubscriptionTransactionInfoRequestOmitted'] == null) {
            throw new runtime.RequiredError(
                'sendSubscriptionTransactionInfoRequestOmitted',
                'Required parameter "sendSubscriptionTransactionInfoRequestOmitted" was null or undefined when calling subscriptionFlowControllerBeginSubscriptionSetup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/subscription-flow/{id}/transaction-info`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendSubscriptionTransactionInfoRequestOmittedToJSON(requestParameters['sendSubscriptionTransactionInfoRequestOmitted']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SendSubscriptionTransactionInfoResponseFromJSON(jsonValue));
    }

    /**
     * Send required transaction info. This action will unlock payment setup.
     * 
     */
    async subscriptionFlowControllerBeginSubscriptionSetup(requestParameters: SubscriptionFlowControllerBeginSubscriptionSetupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SendSubscriptionTransactionInfoResponse> {
        const response = await this.subscriptionFlowControllerBeginSubscriptionSetupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Confirm the email replacement.
     * 
     */
    async subscriptionFlowControllerConfirmEmailReplacementRaw(requestParameters: SubscriptionFlowControllerConfirmEmailReplacementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling subscriptionFlowControllerConfirmEmailReplacement().'
            );
        }

        if (requestParameters['confirmEmailReplacementRequestOmitted'] == null) {
            throw new runtime.RequiredError(
                'confirmEmailReplacementRequestOmitted',
                'Required parameter "confirmEmailReplacementRequestOmitted" was null or undefined when calling subscriptionFlowControllerConfirmEmailReplacement().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/subscription-flow/{id}/replace-email-confirmation`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConfirmEmailReplacementRequestOmittedToJSON(requestParameters['confirmEmailReplacementRequestOmitted']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Confirm the email replacement.
     * 
     */
    async subscriptionFlowControllerConfirmEmailReplacement(requestParameters: SubscriptionFlowControllerConfirmEmailReplacementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.subscriptionFlowControllerConfirmEmailReplacementRaw(requestParameters, initOverrides);
    }

    /**
     * Confirm subscription
     * 
     */
    async subscriptionFlowControllerConfirmSubscriptionRaw(requestParameters: SubscriptionFlowControllerConfirmSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling subscriptionFlowControllerConfirmSubscription().'
            );
        }

        if (requestParameters['confirmSubscriptionPaymentRequestOmitted'] == null) {
            throw new runtime.RequiredError(
                'confirmSubscriptionPaymentRequestOmitted',
                'Required parameter "confirmSubscriptionPaymentRequestOmitted" was null or undefined when calling subscriptionFlowControllerConfirmSubscription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/subscription-flow/{id}/confirmation`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConfirmSubscriptionPaymentRequestOmittedToJSON(requestParameters['confirmSubscriptionPaymentRequestOmitted']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Confirm subscription
     * 
     */
    async subscriptionFlowControllerConfirmSubscription(requestParameters: SubscriptionFlowControllerConfirmSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.subscriptionFlowControllerConfirmSubscriptionRaw(requestParameters, initOverrides);
    }

    /**
     * Get the public price for a membership affiliation plan
     */
    async subscriptionFlowControllerGetMembershipAffiliationPriceRaw(requestParameters: SubscriptionFlowControllerGetMembershipAffiliationPriceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MembershipAffiliationPriceDto>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling subscriptionFlowControllerGetMembershipAffiliationPrice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/subscription-flow/membership-affiliations/{planId}/price`;
        urlPath = urlPath.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters['planId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MembershipAffiliationPriceDtoFromJSON(jsonValue));
    }

    /**
     * Get the public price for a membership affiliation plan
     */
    async subscriptionFlowControllerGetMembershipAffiliationPrice(requestParameters: SubscriptionFlowControllerGetMembershipAffiliationPriceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MembershipAffiliationPriceDto> {
        const response = await this.subscriptionFlowControllerGetMembershipAffiliationPriceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all enabled membership affiliations
     */
    async subscriptionFlowControllerGetMembershipAffiliationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMembershipAffiliationsResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/subscription-flow/membership-affiliations`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMembershipAffiliationsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get all enabled membership affiliations
     */
    async subscriptionFlowControllerGetMembershipAffiliations(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMembershipAffiliationsResponseDto> {
        const response = await this.subscriptionFlowControllerGetMembershipAffiliationsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async subscriptionFlowControllerGetStrategiesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/subscription-flow/strategies`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async subscriptionFlowControllerGetStrategies(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.subscriptionFlowControllerGetStrategiesRaw(initOverrides);
    }

    /**
     * Get subscription flow state. Can be used to confirm email. Returns data required to take next step in flow.
     * 
     */
    async subscriptionFlowControllerGetSubscriptionFlowStateRaw(requestParameters: SubscriptionFlowControllerGetSubscriptionFlowStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSubscriptionFlowStateResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling subscriptionFlowControllerGetSubscriptionFlowState().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['token'] != null) {
            queryParameters['token'] = requestParameters['token'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/subscription-flow/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSubscriptionFlowStateResponseFromJSON(jsonValue));
    }

    /**
     * Get subscription flow state. Can be used to confirm email. Returns data required to take next step in flow.
     * 
     */
    async subscriptionFlowControllerGetSubscriptionFlowState(requestParameters: SubscriptionFlowControllerGetSubscriptionFlowStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSubscriptionFlowStateResponse> {
        const response = await this.subscriptionFlowControllerGetSubscriptionFlowStateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update user info for subscription
     * 
     */
    async subscriptionFlowControllerPatchSubscriptionUserRaw(requestParameters: SubscriptionFlowControllerPatchSubscriptionUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling subscriptionFlowControllerPatchSubscriptionUser().'
            );
        }

        if (requestParameters['patchTransactionInfoRequestOmitted'] == null) {
            throw new runtime.RequiredError(
                'patchTransactionInfoRequestOmitted',
                'Required parameter "patchTransactionInfoRequestOmitted" was null or undefined when calling subscriptionFlowControllerPatchSubscriptionUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/subscription-flow/{id}/transaction-info/user`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchTransactionInfoRequestOmittedToJSON(requestParameters['patchTransactionInfoRequestOmitted']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update user info for subscription
     * 
     */
    async subscriptionFlowControllerPatchSubscriptionUser(requestParameters: SubscriptionFlowControllerPatchSubscriptionUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.subscriptionFlowControllerPatchSubscriptionUserRaw(requestParameters, initOverrides);
    }

    /**
     */
    async subscriptionFlowControllerRemoteSsoStartRaw(requestParameters: SubscriptionFlowControllerRemoteSsoStartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['remoteSsoStartRequest'] == null) {
            throw new runtime.RequiredError(
                'remoteSsoStartRequest',
                'Required parameter "remoteSsoStartRequest" was null or undefined when calling subscriptionFlowControllerRemoteSsoStart().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/subscription-flow/remote-sso-start`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RemoteSsoStartRequestToJSON(requestParameters['remoteSsoStartRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async subscriptionFlowControllerRemoteSsoStart(requestParameters: SubscriptionFlowControllerRemoteSsoStartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.subscriptionFlowControllerRemoteSsoStartRaw(requestParameters, initOverrides);
    }

    /**
     * Start a new subscription flow using email + confirmation link, or continue an existing one.
     * 
     */
    async subscriptionFlowControllerStartEmailSubscriptionFlowRaw(requestParameters: SubscriptionFlowControllerStartEmailSubscriptionFlowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StartSubscriptionFlowResponse>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling subscriptionFlowControllerStartEmailSubscriptionFlow().'
            );
        }

        if (requestParameters['startSubscriptionFlowRequest'] == null) {
            throw new runtime.RequiredError(
                'startSubscriptionFlowRequest',
                'Required parameter "startSubscriptionFlowRequest" was null or undefined when calling subscriptionFlowControllerStartEmailSubscriptionFlow().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/subscription-flow/email/{planId}/start`;
        urlPath = urlPath.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters['planId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StartSubscriptionFlowRequestToJSON(requestParameters['startSubscriptionFlowRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StartSubscriptionFlowResponseFromJSON(jsonValue));
    }

    /**
     * Start a new subscription flow using email + confirmation link, or continue an existing one.
     * 
     */
    async subscriptionFlowControllerStartEmailSubscriptionFlow(requestParameters: SubscriptionFlowControllerStartEmailSubscriptionFlowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StartSubscriptionFlowResponse> {
        const response = await this.subscriptionFlowControllerStartEmailSubscriptionFlowRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Start the process to replace the subscription email.
     * 
     */
    async subscriptionFlowControllerStartReplaceEmailRaw(requestParameters: SubscriptionFlowControllerStartReplaceEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling subscriptionFlowControllerStartReplaceEmail().'
            );
        }

        if (requestParameters['startEmailReplacementRequestOmitted'] == null) {
            throw new runtime.RequiredError(
                'startEmailReplacementRequestOmitted',
                'Required parameter "startEmailReplacementRequestOmitted" was null or undefined when calling subscriptionFlowControllerStartReplaceEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/subscription-flow/{id}/replace-email`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StartEmailReplacementRequestOmittedToJSON(requestParameters['startEmailReplacementRequestOmitted']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Start the process to replace the subscription email.
     * 
     */
    async subscriptionFlowControllerStartReplaceEmail(requestParameters: SubscriptionFlowControllerStartReplaceEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.subscriptionFlowControllerStartReplaceEmailRaw(requestParameters, initOverrides);
    }

    /**
     * Start a new subscription flow or continue an existing one.
     * 
     */
    async subscriptionFlowControllerStartSubscriptionChallengeFlowRaw(requestParameters: SubscriptionFlowControllerStartSubscriptionChallengeFlowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StartSubscriptionFlowResponse>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling subscriptionFlowControllerStartSubscriptionChallengeFlow().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/subscription-flow/challenge/{planId}/start`;
        urlPath = urlPath.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters['planId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StartSubscriptionFlowResponseFromJSON(jsonValue));
    }

    /**
     * Start a new subscription flow or continue an existing one.
     * 
     */
    async subscriptionFlowControllerStartSubscriptionChallengeFlow(requestParameters: SubscriptionFlowControllerStartSubscriptionChallengeFlowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StartSubscriptionFlowResponse> {
        const response = await this.subscriptionFlowControllerStartSubscriptionChallengeFlowRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Start a new subscription flow or continue an existing one.
     * 
     */
    async subscriptionFlowControllerStartSubscriptionTestFlowRaw(requestParameters: SubscriptionFlowControllerStartSubscriptionTestFlowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StartSubscriptionFlowResponse>> {
        if (requestParameters['email'] == null) {
            throw new runtime.RequiredError(
                'email',
                'Required parameter "email" was null or undefined when calling subscriptionFlowControllerStartSubscriptionTestFlow().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['email'] != null) {
            queryParameters['email'] = requestParameters['email'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/subscription-flow/test/start`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StartSubscriptionFlowResponseFromJSON(jsonValue));
    }

    /**
     * Start a new subscription flow or continue an existing one.
     * 
     */
    async subscriptionFlowControllerStartSubscriptionTestFlow(requestParameters: SubscriptionFlowControllerStartSubscriptionTestFlowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StartSubscriptionFlowResponse> {
        const response = await this.subscriptionFlowControllerStartSubscriptionTestFlowRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async subscriptionFlowSSOControllerBeginRaw(requestParameters: SubscriptionFlowSSOControllerBeginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['plan'] == null) {
            throw new runtime.RequiredError(
                'plan',
                'Required parameter "plan" was null or undefined when calling subscriptionFlowSSOControllerBegin().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['provider'] != null) {
            queryParameters['provider'] = requestParameters['provider'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/subscription/sso/{plan}/start`;
        urlPath = urlPath.replace(`{${"plan"}}`, encodeURIComponent(String(requestParameters['plan'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async subscriptionFlowSSOControllerBegin(requestParameters: SubscriptionFlowSSOControllerBeginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.subscriptionFlowSSOControllerBeginRaw(requestParameters, initOverrides);
    }

    /**
     */
    async subscriptionFlowSSOControllerCallbackGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/subscription/sso/callback`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async subscriptionFlowSSOControllerCallbackGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.subscriptionFlowSSOControllerCallbackGetRaw(initOverrides);
    }

    /**
     */
    async subscriptionFlowSSOControllerCallbackPostRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/subscription/sso/callback`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async subscriptionFlowSSOControllerCallbackPost(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.subscriptionFlowSSOControllerCallbackPostRaw(initOverrides);
    }

}
